import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ProtectedRoute } from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import { DashboardGuard } from './components/DashboardGuard';
import ProductsPage from './pages/ProductsPage';
import { SalesPage } from './pages/SalesPage';
import CalendarPage from './pages/CalendarPage';
import TicketsPage from './pages/TicketsPage';
import UsersPage from './pages/UsersPage';
import AlmacenesPage from './pages/AlmacenesPage';
import ProveedoresPage from './pages/ProveedoresPage';
import ComisionesPage from './pages/ComisionesPage';
import ReportsPage from './pages/ReportsPage';
import { CustomersPage } from './pages/CustomersPage';
import PurchasesPage from './pages/PurchasesPage';
import { ApartadosPage } from './pages/ApartadosPage';
import StoresPage from './pages/StoresPage';

import { ZebraProvider } from './context/ZebraContext';
import { IdleTimeoutController } from './components/IdleTimeoutController';

function App() {
  return (
    <Router>
      <ZebraProvider>
        <div className="App">
          <IdleTimeoutController />
          <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              style: {
                background: '#10b981',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#ef4444',
              },
            },
          }}
        />

        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardGuard><DashboardPage /></DashboardGuard></ProtectedRoute>} />
          <Route path="/inventario" element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
          <Route path="/ventas" element={<ProtectedRoute><SalesPage /></ProtectedRoute>} />
          <Route path="/calendario" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
          <Route path="/almacenes" element={<ProtectedRoute><AlmacenesPage /></ProtectedRoute>} />
          <Route path="/proveedores" element={<ProtectedRoute><ProveedoresPage /></ProtectedRoute>} />
          <Route path="/tickets" element={<ProtectedRoute><TicketsPage /></ProtectedRoute>} />
          <Route path="/comisiones" element={<ProtectedRoute><ComisionesPage /></ProtectedRoute>} />
          <Route path="/usuarios" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          <Route path="/reportes" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/clientes" element={<ProtectedRoute><CustomersPage /></ProtectedRoute>} />
          <Route path="/compras" element={<ProtectedRoute><PurchasesPage /></ProtectedRoute>} />
          <Route path="/pre-orders" element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
          <Route path="/apartados" element={<ProtectedRoute><ApartadosPage /></ProtectedRoute>} />
          <Route path="/stores" element={<ProtectedRoute><StoresPage /></ProtectedRoute>} />

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </div>
      </ZebraProvider>
    </Router>
  );
}

export default App;